export default __webpack_public_path__ + "static/media/uvid.f17eebc8.svg";